import type { StepOptionsButton } from 'shepherd.js';
import { ShepherdService } from '@shared/modules/shepherd/shepherd.service';

export type AngularShepherdButton = StepOptionsButton & {
  type?: 'back' | 'cancel' | 'next';
};

export function makeButton(this: ShepherdService, button: AngularShepherdButton) {
  const { classes, disabled, label, secondary, type, text } = button;
  const builtInButtonTypes = ['back', 'cancel', 'next'];

  if (!type) {
    return button;
  }

  if (builtInButtonTypes.indexOf(type) === -1) {
    throw new Error(`'type' property must be one of 'back', 'cancel', or 'next'`);
  }

  return {
    action: this[type].bind(this),
    classes,
    disabled,
    label,
    secondary,
    text,
  };
}

export function elementIsHidden(element: HTMLElement): boolean {
  return element.offsetWidth === 0 && element.offsetHeight === 0;
}
